/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { service } from "@ember/service";

import Component from "@glimmer/component";
import type NavigationService from "parog-web/services/navigation";
import type SemeiaSessionService from "parog-web/services/session";
import type TermsOfUseService from "parog-web/services/terms-of-use";
export default class LegalInfoTermsOfUseComponent extends Component {
  @service declare session: SemeiaSessionService;
  @service declare navigation: NavigationService;
  @service declare termsOfUse: TermsOfUseService;
  get displayArticle51(): boolean {
    const allowedFur = [
      "cardio-transplant",
      "hepato-transplant",
      "pneumo-transplant"
    ];

    return this.session.patient?.followUpReason
      ? allowedFur.includes(this.session.patient.followUpReason)
      : false;
  }

  get shouldAcceptLatestTermsOfUseVersion() {
    return (
      Boolean(this.session?.user) && !this.session?.user?.isAcceptedTermsOfUse
    );
  }

  @action
  back() {
    this.navigation.back();
  }
}
